import { apiFetch } from './api';
import type { Story } from '../types/models';

export async function listStories(): Promise<Story[]> {
  const res = await apiFetch<{ stories: Story[] }>('/stories');
  return res.stories;
}
